import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { WorldpayForm, WorldpayFormField } from '@checkout/util-models';
import { AddressFormBuilder } from '@domgen/dgx-fe-forms/address';
import { FormControlValidators } from '@domgen/dgx-fe-forms/shared';
import { TranslateService } from '@domgen/dgx-fe-i18n';
import { FeatureCardTranslationDictionary } from '../../models/i18n/feature-card-translation-dictionary.interface';
import { WorldpayFormConfig } from '../../models/worldpay/worldpay-form-config.interface';

@Injectable()
export class WorldpayFormBuilder {
  constructor(
    private readonly addressFormBuilder: AddressFormBuilder,
    private readonly formBuilder: FormBuilder,
    private readonly translateService: TranslateService<FeatureCardTranslationDictionary>
  ) {}

  buildWorldpayForm(config: WorldpayFormConfig): FormGroup<WorldpayForm> {
    return this.formBuilder.group(this.buildWorldpayFormConfig(config));
  }

  private buildWorldpayFormConfig(config: WorldpayFormConfig): WorldpayForm {
    const { customerDetails } = config;

    return {
      [WorldpayFormField.Address]: this.addressFormBuilder.buildAddressForm(
        customerDetails?.address
      ),
      [WorldpayFormField.BillingAddress]:
        this.addressFormBuilder.buildAdditionalAddressForm(
          customerDetails?.address
        ),
      [WorldpayFormField.TermsAndConditions]: new FormControl(
        null,
        Validators.compose([
          FormControlValidators.requiredTrueConditionally(
            Boolean(config.termsAndConditionsFeatureEnabled),
            this.translateService.translate(
              'CARD_FORM_TERMS_AND_CONDITIONS_ERROR_REQUIRED'
            )
          ),
        ])
      ),
      [WorldpayFormField.PaperlessPreference]: new FormControl(null),
    };
  }
}
